function getDragAfterElement(container, y) {
  const draggableElements = [
    ...container.querySelectorAll('[draggable]:not(.dragging)')
  ]

  return draggableElements.reduce(
    (closest, child) => {
      const box = child.getBoundingClientRect()
      const offset = y - box.top - box.height / 2
      if (offset < 0 && offset > closest.offset) {
        return { offset: offset, element: child }
      } else {
        return closest
      }
    },
    { offset: Number.NEGATIVE_INFINITY }
  ).element
}

export default {
  mounted() {
    this.dropTarget = null

    this.el.addEventListener('dragover', (event) => {
      event.preventDefault()

      // The dragging element is intentionally not moved during dragover — a drop outside
      // the zone sends no event, so the element stays in its original position keeping the UI
      // in sync with the backend.
      const afterElement = getDragAfterElement(this.el, event.clientY)

      if (afterElement == null) {
        this.dropTarget = 'bottom'
      } else {
        this.dropTarget = afterElement.getAttribute('data-id')
      }
    })

    this.el.addEventListener('drop', (e) => {
      e.preventDefault()
      const draggedId = this.el
        .querySelector('[draggable].dragging')
        .getAttribute('data-id')
      if (draggedId && this.dropTarget) {
        this.pushEvent('reorder', {
          target: this.dropTarget,
          entity_id: draggedId,
          list_id: this.el.id
        })
      }
      this.dropTarget = null
    })
  }
}
